<template>
  <GeneralPDV />
</template>

<script>
import GeneralPDV from '../../components/GeneralPDV/GeneralPDV.vue'
export default {
    components:{
        GeneralPDV,
    }
}
</script>